import {
  GET_ALL_USERS,
  GET_SPECIFIC_USER,
  GET_ALL_ROLES,
  GET_ALL_AGENTS,
  GET_ALL_QUEUES,
  GET_ALL_RAMAIS,
  GET_ALL_TAGS,
  GET_ALL_CONFERENCIAS,
  GET_ALL_PESQUISAS,
} from './mutation-types'

export default {
  [GET_ALL_USERS]: (state, users) => {
    state.users = users
  },
  [GET_SPECIFIC_USER]: (state, user) => {
    state.user = user
  },
  [GET_ALL_ROLES]: (state, roles) => {
    state.roles = roles
  },
  [GET_ALL_AGENTS]: (state, agents) => {
    state.agents = agents
  },
  [GET_ALL_QUEUES]: (state, queues) => {
    state.queues = queues
  },
  [GET_ALL_RAMAIS]: (state, ramais) => {
    state.ramais = ramais
  },
  [GET_ALL_TAGS]: (state, tags) => {
    state.tags = tags
  },
  [GET_ALL_CONFERENCIAS]: (state, conferencias) => {
    state.conferencias = conferencias
  },
  [GET_ALL_PESQUISAS]: (state, pesquisas) => {
    state.pesquisas = pesquisas
  },
}
